'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./cart/cart'));
    processInclude(require('richemont/cart/cart'));
    processInclude(require('richemont/cart/crc'));
    processInclude(require('richemont/libs/webGLViewer'));
    processInclude(require('richemont/components/productPersonalization'));
});
